import { Coding } from './coding.model';
import { ValueSetReference } from './value-set-reference.model';

export class CodingAdditionalInfo {
  constructor(
    public valueSets: ValueSetReference[],
    public relatedTerms: Coding[]) {
  }
}
